import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { firstValueFrom } from 'rxjs';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { ProviderDto, ProviderPagedRequestDto, ProviderService, ProviderState } from 'src/app/proxy/providers';
import { AppConsts } from '../../AppConsts';

@Component({
  selector: 'app-provider-autocomplete',
  standalone: false,
  templateUrl: './provider-autocomplete.component.html',
})
export class ProviderAutocompleteComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() isDisabled: boolean;
  @Input() providerStateFilter?: ProviderState;
  @Input() labelText?: string;
  @Input() set preselectedProviderId(value: number) {
    this.selectedProviderId = value;
    this.setProviderSelectedIfCorrespond();
  }
  @Output() changeSelectedProvider = new EventEmitter<ProviderDto>();
  get labelToShow(): string {
    return this.labelText ?? this.l('::Provider');
  }
  
  providers: ProviderDto[];
  selectedProvider: ProviderDto;
  private selectedProviderId: number;

  constructor(injector: Injector, private readonly _providerService: ProviderService) {
    super(injector);
  }
  ngOnInit(): void {
    this.loadProviders();
    this.onChangeSelectedProvider();
  }

  async loadProviders(filter: AutoCompleteCompleteEvent = undefined): Promise<void> {
    try {
      this.showLoading();

      const inputDto: ProviderPagedRequestDto = {
        name: filter?.query,
        maxResultCount: AppConsts.MaxPageSize,
        skipCount: 0,
        state: this.providerStateFilter
      };

      this.providers =
        (await firstValueFrom(this._providerService.getAllByInput(inputDto)))?.items || [];
      this.setProviderSelectedIfCorrespond();
    } finally {
      this.hideLoading();
    }
  }

  onChangeSelectedProvider(): void {
    this.changeSelectedProvider.emit(this.selectedProvider);
  }

  setSelectedProviderId(providerId: number): void {
    this.selectedProviderId = providerId;
    if (this.providers && this.providers.length > 0) {
      this.selectedProvider = this.providers.find(provider => provider.id === providerId);
    }
  }

  private setProviderSelectedIfCorrespond(): void {
    if (this.selectedProviderId && this.providers) {
      this.selectedProvider = this.providers.find(
        provider => provider.id === this.selectedProviderId
      );
    }
  }
}
